import { render, staticRenderFns } from "./ClassMapper.vue?vue&type=template&id=4295991a&"
import script from "./ClassMapper.vue?vue&type=script&lang=js&"
export * from "./ClassMapper.vue?vue&type=script&lang=js&"
import style0 from "./ClassMapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports